import { Component, Input, OnInit } from '@angular/core';
import { WarrantyInfo } from 'src/app/data-models/widgets/warranty-info.model';
import { WinRT } from '@lenovo/tan-client-bridge-le';

@Component({
	selector: 'vtr-widget-common-warranty',
	templateUrl: './widget-common-warranty.component.html',
	styleUrls: ['./widget-common-warranty.component.scss'],
})
export class WidgetCommonWarrantyComponent {
	@Input() title: string;
	@Input() warrantyData: WarrantyInfo;
	@Input() btnIndex = 0;
	@Input() isOnline: boolean;
	status = {
		title: [
			'support.warranty.titleInWarranty',
			'support.warranty.titleWarrantyExpired',
			'support.warranty.titleWarrantyNotFound',
		],
		detail: [
			'support.warranty.statusInWarranty',
			'support.warranty.statusWarrantyExpired',
			'support.warranty.statusWarrantyNotFound',
		],
	};

	constructor() {}

	public onClick() {
		WinRT.launchUri(this.warrantyData.info.url);
	}
}
